import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';

const tabs = [
  {
    "title": "All orders",
    "resource": "admin_rest/allorder",
    "columns": [
      "id",
      "created",
      "user",
      "pair",
      "operation",
      "type",
      "quantity",
      "quantity_left",
      "price",
      "state"
    ]
  },
  {
    "title": "Customer orders",
    "resource": "admin_rest/allordernobot"
  },
  {
    "title": "Trades",
    "resource": "admin_rest/match"
  },
  {
    "title": "Executions",
    "resource": "core/executionresult"
  },
  {
    "title": "Order changes",
    "resource": "core/orderchangehistory"
  },
  {
    "title": "State history",
    "resource": "core/orderstatechangehistory"
  }
];

export default function OrdersPage() {
  return <ResourceWorkspace title="Order operations"  tabs={tabs} />;
}
